import React from "react";
import { connect } from "react-redux";
import { func } from "prop-types";

import Icon from "../Icon";
import PageContent from "../PageContent";
import { go } from "../../logic/actions/navigation";
import {
  FACE_LIVENESS_3D,
  INSTRUCTION_VIDEO_FACE_LIVENESS_3D,
} from "../../logic/enums/pages";
import { isMobile } from "../../logic/deviceType";

PageInstructionsFaceLiveness3D.propTypes = {
  go: func,
};

export function PageInstructionsFaceLiveness3D({ go }) {
  return (
    <PageContent progressBar={true} progressPercentage={90}>
      <h1 style={{ margin: "5px" }}>Extra Checks</h1>
      <p className="center">
        We will ask you now to capture a video of moving your face from arm's
        length towards your face.
      </p>

      <div className="panel border-green">
        <div className="column">
          <hr />
          <div className="row">
            <Icon name="Focus-round" color="gray" />
            <p>Place your face inside the oval on the screen</p>
          </div>
          <hr />
          <div className="row">
            <Icon name="Focus-round" color="gray" />
            <p>
              Wait for the countdown 3-2-1 to end and start moving the phone
              towards your face
            </p>
          </div>
          <hr />
          <div className="row">
            <Icon name="Focus-round" color="gray" />
            <p>Keep the face inside the oval while moving</p>
          </div>
          <hr />
          <div className="row">
            <Icon name="Focus-round" color="gray" />
            <p>Wait for the process to end</p>
          </div>
          <hr />
          <div className="row">
            <Icon name="Tap" color="gray" />
            <p>Tap on next when ready</p>
          </div>
        </div>
      </div>
      <button
        className="btn green"
        onClick={() => {
          isMobile(navigator.userAgent)
            ? go(INSTRUCTION_VIDEO_FACE_LIVENESS_3D)
            : go(FACE_LIVENESS_3D);
        }}
      >
        Continue
      </button>
    </PageContent>
  );
}

export default connect(null, { go })(PageInstructionsFaceLiveness3D);
